import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectThemeMode } from '../../redux/slices/themeSlice';
import { getPlatform } from '../../common/firebase';
import { BodyMedium } from '../../components/Texts/index';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100vh;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  z-index: 1;
`;

const StoreImage = styled.img`
  max-width: 200px;
  height: auto;
  cursor: pointer;
  transition: opacity 0.2s ease;

  @media (hover: hover) {
    &:hover {
      opacity: 0.8;
    }
  }
`;

const StoresContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
`;

const BlueCircle = styled.div`
  position: fixed;
  z-index: 0;
  width: 100vw;
  height: 100vw;
  background: radial-gradient(
    circle,
    ${({ theme }) => theme.primary.primary}50 0%,
    ${({ theme }) => theme.primary.primary}00 50%
  );
  border-radius: 50%;
  @media ${PHONE_MEDIA_QUERY} {
    background: radial-gradient(
      circle,
      ${({ theme }) => theme.primary.primary}50 0%,
      ${({ theme }) => theme.primary.primary}00 75%
    );
  }
`;

const DownloadApp = () => {
  const themeMode = useSelector(selectThemeMode);
  const platform = getPlatform();
  const isAndroid = platform === 'android';
  const isIOS = platform === 'ios';
  const isDark = themeMode === 'dark';

  const openPlayStore = () => {
    window.open(
      'https://play.google.com/store/apps/details?id=xyz.deks.app',
      '_blank',
    );
  };

  const openAppStore = () => {
    window.open(
      'https://apps.apple.com/us/app/deks-xyz/id6749857801',
      '_blank',
    );
  };

  const getImageSrc = () => {
    if (isAndroid) {
      return isDark
        ? '/download/playstore-dark.webp'
        : '/download/playstore-light.webp';
    } else if (isIOS) {
      return isDark
        ? '/download/appstore-dark.webp'
        : '/download/appstore-light.webp';
    } else {
      // Show both for unknown platforms
      return null;
    }
  };

  const getBothImages = () => {
    return (
      <>
        <StoreImage
          onClick={openPlayStore}
          src={
            isDark
              ? '/download/playstore-dark.webp'
              : '/download/playstore-light.webp'
          }
          alt='Get it on Google Play'
        />
        <StoreImage
          onClick={openAppStore}
          src={
            isDark
              ? '/download/appstore-dark.webp'
              : '/download/appstore-light.webp'
          }
          alt='Download on the App Store'
        />
      </>
    );
  };

  const imageSrc = getImageSrc();

  return (
    <Container>
      <BlueCircle />
      <InnerContainer>
        <img
          style={{
            width: '90%',
            maxWidth: '200px',
          }}
          src={
            themeMode === 'light'
              ? '/logo-footer.webp'
              : '/logo-footer-dark.webp'
          }
          alt='Deks Logo'
        />
        <BodyMedium>
          Experience the easiest way to gift on crypto — download Deks today.
        </BodyMedium>
        {imageSrc ? (
          <StoreImage
            onClick={() => {
              if (platform === 'android') {
                openPlayStore();
              } else if (platform === 'ios') {
                openAppStore();
              }
            }}
            src={imageSrc}
            alt={
              platform === 'android'
                ? 'Get it on Google Play'
                : 'Download on the App Store'
            }
          />
        ) : (
          <StoresContainer>{getBothImages()}</StoresContainer>
        )}
      </InnerContainer>
    </Container>
  );
};

export default DownloadApp;
